<div class="card">

    <div class="row mt-1" style="padding-left: 10px;">
        <div class="col-md-3">
            <ng-select [clearable]="true" [(ngModel)]="selectedGarantieProduitBareme" placeholder="Garantie"
                [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsGarantieProduitBareme" [value]="item">{{
                    item?.libelle }}
                </ng-option>
            </ng-select>
        </div>


        <div class="col-md-3">
            <input [ngModelOptions]="{standalone:true}" type="text" placeholder="Date effet"
                autocomplete="off" class="form-control" bsDatepicker [bsConfig]="{
                    dateInputFormat: 'DD/MM/YYYY',
                    containerClass: 'theme-dark-blue'
                }" [(ngModel)]="dateEffetToAdd" />
        </div>

        <div class="col-md-3 d-flex align-items-center gap-1">
            <a class="btn btn-sm btn-info" style="cursor: pointer; white-space:nowrap;" title="Ajouter" (click)="onAddItemToList()">
                Ajouter <i class="fa fa-plus"></i>
            </a>
            <a class="btn btn-sm btn-info" style="cursor: pointer; white-space:nowrap;" title="Actualiser"
                (click)="getItemsGarantieBareme()">
                Actualiser <i class="fa fa-redo-alt"></i>
            </a>
            <!-- <a class="btn btn-md btn-primary" style="cursor: pointer" (click)="fillWithDefauldValues()"
                title="Remplir le champs vides avec valeurs par défaut">
                Remplir
                <i class="fa fa-fill"></i></a> -->
            <!-- &nbsp;
            <a class="btn btn-md btn-danger" style="cursor: pointer" (click)="clearUp()" title="Vider le formulaire">
                Vider
                <i class="fa fa-times"></i></a> -->
        </div>
        <!-- <div class="row pagination-part"> -->
        <!-- <div class="col-md-3" style="text-align: center">
              <pagination [maxSize]="5" [boundaryLinks]="true" [itemsPerPage]="itemsPerPage"
                  [totalItems]="totalItems" [(ngModel)]="currentPage" class="pagination-sm"
                  previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
                  lastText="&raquo;" (pageChanged)="pageChanged($event)">
              </pagination>
          </div> -->

        <!-- <div class="col-md-4">
              <div class="paginator-per-page">
                  <app-element-by-page-paginator (paginationChange)="
changePaginationSize($event)
" [defaultItemPerPage]="itemsPerPage">
                  </app-element-by-page-paginator>

                  <span class="span_total_entree pull-right">Total : {{ totalItems
                      }}</span>
              </div>
          </div> -->
        <!-- </div> -->
    </div>




    <div class="row">

        <div class="col-md-12">

            <div class="body table-responsive" style="min-height: 300px;max-width: 100%;overflow:auto">

                <table class="table table-bordered">
                    <thead>

                        <tr class="custom-table-head">
                            <th>Garantie</th>
                            <th>Date effet</th>
                            <th>Prise en charge?</th>
                            <th>Genre</th>
                            <!-- <th>Jour ferié?</th>
                            <th style="width: 20%;">Type majo.</th>
                            <th>Valeur majo.</th>
                            <th>Tranche d'age</th>
                            <th>Age min</th>
                            <th>Age max</th> -->
                            <th>Remboursement</th>
                            <!-- <th>Nb. transact.</th>
                            <th>Plafonds</th> -->
                            <th>Plafonds</th>
                            <th>Horaires</th>
                            <th>Réseau</th>
                            <th>Autre</th>
                            <th>Option</th>

                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="loading">
                            <tr class="skeleton-row" *ngFor="let _ of [1,2,3,4,5]">
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                                <td><div class="skeleton-cell"></div></td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="!loading">
                        <tr *ngFor="let item of itemsGarantieBareme; let indice = index" style="cursor: pointer;">
                            <td>{{item.libelle}}</td>
                            <td>
                                <input [ngModelOptions]="{standalone:true}" type="text" placeholder="Date effet"
                                    autocomplete="off"  bsDatepicker [bsConfig]="{
                                              dateInputFormat: 'DD/MM/YYYY',
                                              containerClass: 'theme-dark-blue'
                                            }" [(ngModel)]="item.date_effet"
                                    (ngModelChange)="onDateEffetChange(item, indice)" />
                            </td>
                            <td>

                                <ng-select (change)="updateItem(item)" [clearable]="false" [disabled]="item.is_disabled"
                                    [(ngModel)]="item.is_pc" placeholder="Choisissez "
                                    [ngModelOptions]="{standalone:true}" [multiple]="false" [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of autorizationOptions" [value]="item.value">{{
                                        item?.libelle}}
                                    </ng-option>
                                </ng-select>
                            </td>
                            <td>
                                <ng-select (change)="updateItem(item)" [clearable]="true"
                                    [disabled]="item.is_disabled || item.is_disabled_genre" [(ngModel)]="item.genre_id"
                                    placeholder="Choisissez genre" [ngModelOptions]="{standalone:true}"
                                    [multiple]="false" [closeOnSelect]="true">
                                    <ng-option [value]="null">Tous</ng-option>
                                    <ng-option *ngFor="let item of itemsGenre" [value]="item.id">{{
                                        item?.libelle}}
                                    </ng-option>
                                </ng-select>
                            </td>
                            <td>
                                <ng-select (change)="updateItem(item)" [clearable]="true"
                                    [(ngModel)]="item.type_remboursement_id" placeholder="Choisissez genre"
                                    [ngModelOptions]="{standalone:true}" [multiple]="false" [closeOnSelect]="true">
                                    <ng-option *ngFor="let item of itemsTypeRemboursement" [value]="item.id">{{
                                        item?.libelle}}
                                    </ng-option>
                                </ng-select>
                            </td>

                            <!-- <td>
                                <button (click)="openModalTransaction(item,templateCrudNbTransaction)"
                                    class="btn btn-info"> <i class="fa fa-plus"></i></button>
                            </td>
                            <td>
                                <button (click)="openModalPlafond(item,templateCrudPlafond)" class="btn btn-info"> <i
                                        class="fa fa-plus"></i></button>
                            </td> -->
                            <td style="text-align: center;">
                                <button [disabled]="!item.is_old"
                                    (click)="openModalPlafondTransaction(item,templateDynamicPlafondTransationConfig)"
                                    class="btn btn-info"> <i class="fa fa-plus"></i></button>
                            </td>
                            <td>
                                <button (click)="openModal(item,templateCrud)" class="btn btn-info"> <i
                                        class="fa fa-plus"></i></button>
                            </td>
                            <td>
                                <button [disabled]="!item.is_old"
                                    (click)="openModalReseauIntervalle(item,templateReseauSoinIntervalleConfig)"
                                    class="btn btn-info"> <i class="fa fa-plus"></i></button>
                            </td>
                            <td>
                                <button (click)="openModalTransaction(item,templateCrudAutreConfig)"
                                    class="btn btn-info"> <i class="fa fa-plus"></i></button>
                            </td>
                            <td>
                                <div class="custom-td-action">
                                    <button class="btn btn-primary" (click)="confirmSaveItem(item)">{{ item.is_old ? 'Actualiser' : 'Sauvegarder' }}</button>

                                    <a *ngIf="item.is_old" title="Supprimer" (click)="confirmDeleteItem(item)"
                                        class="custom-btn-delete">
                                        <i class="fa fa-trash"></i></a>

                                    <a *ngIf="!item.is_old" title="Supprimer"
                                        (click)="itemsGarantieBareme.splice(item,1)" class="custom-btn-delete">
                                        <i class="fa fa-trash"></i></a>
                                </div>
                            </td>
                        </tr>
                        </ng-container>
                    </tbody>


                </table>
            </div>

        </div>

    </div>

    <div *ngIf="items && items.length" class="row" style="position: absolute; bottom: 0;right:0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="text-align: right;">

            <button type="button" class="btn btn-md btn-cancel" (click)="onHideForm()">
                Annuler
            </button>
            &nbsp;&nbsp;

            <button (click)="confirmSaveItem()" type="button" class="btn btn-md custom_btn_primary"
                [class.auth-spinner]="loading" [disabled]="loading">
                Sauvegarder
            </button>


        </div>
    </div>

    <ng-template #templateCrud>
        <div class="modal-header">
            <h4 class="modal-title pull-left">
                Horaires {{garantieRow.libelle}}
            </h4>
            <button mat-icon-button class="pull-right" (click)="updateHoraire()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" [ngBusy]="{
busy: busySave,
message: 'Veuillez patienter ...',
backdrop: false
}">
            <form class="m-1">
                <div class="row">

                    <table class="table table-stripped table-bordered table-hover">
                        <thead>
                            <tr class="custom-table-head">
                                <!-- <th style="width: 9%;">
                                  

                                  <a style="cursor: pointer;margin-top: 5px;"
                                      (click)="currentPage = 0; getGarantieBaremeStatutJourAutorise()"
                                      title="Actualiser">
                                      <i class="fa fa-redo-alt"></i></a>
                                  Choix
                              </th> -->

                                <th>Jour</th>
                                <th>Heure debut</th>
                                <th>Heure fin</th>
                            </tr>
                        </thead>
                        <tbody [class.isDataToCopy]="isDataToCopy">
                            <tr style="cursor: pointer;">

                                <td>Lundi</td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.lundi_start" type="time"></td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.lundi_end" type="time"></td>
                            </tr>
                            <tr style="cursor: pointer;">

                                <td>Mardi</td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.mardi_start" type="time"></td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.mardi_end" type="time"></td>
                            </tr>
                            <tr style="cursor: pointer;">

                                <td>Mercredi</td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.mercredi_start" type="time"></td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.mercredi_end" type="time"></td>
                            </tr>
                            <tr style="cursor: pointer;">

                                <td>Jeudi</td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.jeudi_start" type="time"></td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.jeudi_end" type="time"></td>
                            </tr>
                            <tr style="cursor: pointer;">

                                <td>Vendredi</td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.vendredi_start" type="time"></td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.vendredi_end" type="time"></td>
                            </tr>
                            <tr style="cursor: pointer;">

                                <td>Samedi</td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.samedi_start" type="time"></td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.samedi_end" type="time"></td>
                            </tr>
                            <tr style="cursor: pointer;">

                                <td>Dimanche</td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.dimanche_start" type="time"></td>
                                <td><input class="form-control" [ngModelOptions]="{standalone:true}"
                                        [(ngModel)]="currentGarantieBareme.dimanche_end" type="time"></td>
                            </tr>

                        </tbody>

                    </table>


                </div>
            </form>
        </div>

        <div class="modal-footer modal-footer-custom">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <button (click)="applyHoraire()" type="button" class="btn btn-md custom_btn_primary pull-right"
                    [class.auth-spinner]="loading" [disabled]="loading">
                    Ok
                </button>
                <!-- <button type="button" class="btn btn-md btn-cancel pull-right" (click)="modalRef.hide()">
                  Annuler
              </button> -->
            </div>
        </div>
    </ng-template>
    <ng-template #templateCrudPlafond>
        <div class="modal-header">
            <h4 class="modal-title pull-left">
                Plafonds {{garantieRow.libelle}}
            </h4>
            <button mat-icon-button class="pull-right" (click)="updateHoraire()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" [ngBusy]="{
busy: busySave,
message: 'Veuillez patienter ...',
backdrop: false
}">
            <div class="row">
                <div class="col-md-3">
                    <label>Plafond global</label>

                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond global" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_global" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par transaction</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par transaction" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_transaction" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par famille/jour</label>
                    <input (blur)="updateItem(item)" [disabled]="currentGarantieBareme.is_disabled" class="form-control"
                        placeholder="Plafond par famille/jour" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_famille_jour" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par famille semaine</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par famille semaine"
                        [ngModelOptions]="{standalone:true}" [(ngModel)]="currentGarantieBareme.plafond_famille_semaine"
                        type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par famille mois</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par famille mois" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_famille_mois" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par famille trim</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par famille trim" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_famille_trimestre" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par famille semestre</label>
                    <input (blur)="updateItem(item)" [disabled]="currentGarantieBareme.is_disabled" class="form-control"
                        placeholder="Plafond par famille semestre" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_famille_semestre" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par famille/an</label>
                    <input (blur)="updateItem(item)" [disabled]="currentGarantieBareme.is_disabled" class="form-control"
                        placeholder="Plafond par famille/an" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_famille_annee" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par individu</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par individu" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_individuel" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond individu jour</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond individu jour" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_individuel_jour" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par individu semaine</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par individu semaine"
                        [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_individuel_semaine" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par individu mois</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par individu mois"
                        [ngModelOptions]="{standalone:true}" [(ngModel)]="currentGarantieBareme.plafond_individuel_mois"
                        type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par individu trim</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par individu trim"
                        [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_individuel_trimestre" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par individu semestre</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par individu semestre"
                        [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_individuel_semestre" type="text" mask="separator">
                </div>

                <div class="col-md-3">
                    <label>Plafond par individu année</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Plafond par individu année"
                        [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.plafond_individuel_annee" type="text" mask="separator">
                </div>
            </div>

        </div>

        <div class="modal-footer modal-footer-custom">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <button (click)="applyCurrentBareme()" type="button" class="btn btn-md custom_btn_primary pull-right"
                    [class.auth-spinner]="loading" [disabled]="loading">
                    Ok
                </button>
                <!-- <button type="button" class="btn btn-md btn-cancel pull-right" (click)="modalRef.hide()">
                  Annuler
              </button> -->
            </div>
        </div>
    </ng-template>
    <ng-template #templateCrudNbTransaction>
        <div class="modal-header">
            <h4 class="modal-title pull-left">
                {{garantieRow.libelle}} / Nombre de transactions
            </h4>
            <button mat-icon-button class="pull-right" (click)="updateHoraire()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" [ngBusy]="{
busy: busySave,
message: 'Veuillez patienter ...',
backdrop: false
}">
            <div class="row">
                <div class="col-md-3">
                    <label>Par jour</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transact_jour" type="text"
                        mask="separator" placeholder="jour">
                </div>

                <div class="col-md-3">
                    <label>Par semaine</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transact_semaine" type="text"
                        mask="separator" placeholder="semaine">
                </div>

                <div class="col-md-3">
                    <label>Par mois</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transact_mois" type="text"
                        mask="separator" placeholder="mois">
                </div>

                <div class="col-md-3">
                    <label>Par trimestre</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transact_trimestre" type="text"
                        mask="separator" placeholder="trimestre">
                </div>

                <div class="col-md-3">
                    <label>Par semestre</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transact_semestre" type="text"
                        mask="separator" placeholder="semestre">
                </div>

                <div class="col-md-3">
                    <label>Par année</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transact_annee" type="text"
                        mask="separator" placeholder="année">
                </div>

                <div class="col-md-3">
                    <label>Par exercice</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transact_exercice" type="text"
                        mask="separator" placeholder="exercice">
                </div>

                <div class="col-md-3">
                    <label>Par famille/jour</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_famille_jour"
                        type="text" mask="separator" placeholder="Famille/jour">
                </div>

                <div class="col-md-3">
                    <label>Par famille/semaine</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_famille_semaine"
                        type="text" mask="separator" placeholder="Famille/semaine">
                </div>

                <div class="col-md-3">
                    <label>Par famille/mois</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_famille_mois"
                        type="text" mask="separator" placeholder="Famille/mois">
                </div>

                <div class="col-md-3">
                    <label>Par famille/trimestre</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_famille_trimestre"
                        type="text" mask="separator" placeholder="Famille/trimestre">
                </div>

                <div class="col-md-3">
                    <label>Par famille/semestre</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_famille_semestre"
                        type="text" mask="separator" placeholder="Famille/semestre">
                </div>

                <div class="col-md-3">
                    <label>Par famille/année</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_famille_annee"
                        type="text" mask="separator" placeholder="Famille/année">
                </div>

                <div class="col-md-3">
                    <label>Par individu/jour</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_individuel_jour"
                        type="text" mask="separator" placeholder="Individuel/jour">
                </div>

                <div class="col-md-3">
                    <label>Par individu/semaine</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_individuel_semaine"
                        type="text" mask="separator" placeholder="Individuel/semaine">
                </div>

                <div class="col-md-3">
                    <label>Par individu/mois</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_individuel_mois"
                        type="text" mask="separator" placeholder="Individuel/mois">
                </div>

                <div class="col-md-3">
                    <label>Par individu/trimestre</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" [(ngModel)]="currentGarantieBareme.nombre_transaction_individuel_trimestre"
                        type="text" mask="separator" placeholder="Individuel/trimestre">
                </div>
            </div>

        </div>

        <div class="modal-footer modal-footer-custom">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <button (click)="applyCurrentBareme()" type="button" class="btn btn-md custom_btn_primary pull-right"
                    [class.auth-spinner]="loading" [disabled]="loading">
                    Ok
                </button>
                <!-- <button type="button" class="btn btn-md btn-cancel pull-right" (click)="modalRef.hide()">
                  Annuler
              </button> -->
            </div>
        </div>
    </ng-template>
    <ng-template #templateCrudAutreConfig>
        <div class="modal-header">
            <h4 class="modal-title pull-left">
                {{garantieRow.libelle}} / Autre configuration
            </h4>
            <button mat-icon-button class="pull-right" (click)="updateHoraire()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" [ngBusy]="{
busy: busySave,
message: 'Veuillez patienter ...',
backdrop: false
}">
            <div class="row">
                <div class="col col-md-4">
                    <label>Délai de carence (jours)</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Délai de carence" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.delai_carence" type="text" mask="separator">
                </div>
                <div class="col col-md-4">
                    <label>Ticket modérateur (%)</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Ticket modérateur" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.ticket_moderateur" type="text" mask="separator">
                </div>
                <div class="col col-md-4">
                    <label>Forfait</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Forfait" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.forfait" type="text" mask="separator">
                </div>
                <div class="col col-md-4">
                    <label>Age minimum autorisé</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Age min" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.age_min" type="text" mask="separator">
                </div>
                <div class="col col-md-4" style="margin-bottom: 3px;">
                    <label>Age maximum autorisé</label>
                    <input (blur)="updateItem(currentGarantieBareme)" class="form-control" placeholder="Age max"
                        [ngModelOptions]="{standalone:true}" [(ngModel)]="currentGarantieBareme.age_max" type="text"
                        mask="separator">
                </div>


                <div class="col col-md-4">
                    <label>Tranche d'age autorisé</label>

                    <ng-select (change)="updateItem(currentGarantieBareme)" [clearable]="true"
                        [disabled]="currentGarantieBareme.is_disabled"
                        [(ngModel)]="currentGarantieBareme.tranche_age_id" placeholder="Choisissez tranche age"
                        [ngModelOptions]="{standalone:true}" id="tranche_age_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsTrancheAge" [value]="item.id">{{
                            item?.libelle+' '+('(de '+item?.age_min+' à '+item?.age_max+' an(s))') }}
                        </ng-option>
                    </ng-select>
                </div>

                <div class="col col-md-4">

                    <label>Type de majoration</label>

                    <ng-select (change)="updateItem(currentGarantieBareme)" [clearable]="false"
                        [disabled]="currentGarantieBareme.is_disabled"
                        [(ngModel)]="currentGarantieBareme.type_majoration" placeholder="Choisissez "
                        [ngModelOptions]="{standalone:true}" [multiple]="false" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsTypeMajoration" [value]="item.value">{{
                            item?.libelle}}
                        </ng-option>
                    </ng-select>
                </div>

                <div class="col col-md-4">
                    <label>Valeur de majoration</label>

                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Valeur majoration" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.valeur_majoration" type="text" mask="separator">
                </div>
                <div class="col col-md-4">
                    <label>Jours fériés autorisés?</label>


                    <ng-select (change)="updateItem(currentGarantieBareme)" [clearable]="false"
                        [disabled]="currentGarantieBareme.is_disabled"
                        [(ngModel)]="currentGarantieBareme.is_jour_ferie_allowed" placeholder="Choisissez "
                        [ngModelOptions]="{standalone:true}" [multiple]="false" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of autorizationOptions" [value]="item.value">{{
                            item?.libelle}}
                        </ng-option>
                    </ng-select>
                </div>

                <div class="col col-md-4">
                    <label>Seuil alerte conso(%)</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Valeur majoration" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.seuil_alerte_conso" type="text" mask="separator">
                </div>
                <div class="col col-md-4">
                    <label>Seuil blocage tp(%)</label>
                    <input (blur)="updateItem(currentGarantieBareme)" [disabled]="currentGarantieBareme.is_disabled"
                        class="form-control" placeholder="Valeur majoration" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="currentGarantieBareme.seuil_suspension_tiers_payant" type="text" mask="separator">
                </div>





            </div>

        </div>

        <div class="modal-footer modal-footer-custom">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <button (click)="applyCurrentBareme()" type="button" class="btn btn-md custom_btn_primary pull-right"
                    [class.auth-spinner]="loading" [disabled]="loading">
                    Ok
                </button>
            </div>
        </div>
    </ng-template>



    <ng-template #templateDynamicPlafondTransationConfig>
        <div class="modal-header">
            <h4 class="modal-title pull-left">
                {{garantieRow.libelle}} / Transaction et plafonds
            </h4>
            <button mat-icon-button class="pull-right" (click)="modalRefDynamicPlafondTransacton.hide()"
                aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" [ngBusy]="{
busy: busySave,
message: 'Veuillez patienter ...',
backdrop: false
}">
            <div class="row">
                <div class="col col-md-2">
                    <label>Périodicité</label>

                    <ng-select [clearable]="true" [(ngModel)]="itemToAdd.periodicite_id"
                        placeholder="Choisissez périodicité" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsPeriodicite" [value]="item.id">{{
                            item?.libelle }} ({{item.nombre_jours}} Jour(s))
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col col-md-2">
                    <label>Nbr. transactions individuel</label>
                    <input class="form-control" placeholder="Nombre de transactions"
                        [ngModelOptions]="{standalone:true}" [(ngModel)]="itemToAdd.nombre_transaction" type="text"
                        mask="separator">
                </div>
                <div class="col col-md-2">
                    <label>Nbr. transactions famille</label>
                    <input class="form-control" placeholder="Nbr. transactions famille"
                        [ngModelOptions]="{standalone:true}" [(ngModel)]="itemToAdd.nombre_transaction_famille"
                        type="text" mask="separator">
                </div>
                <div class="col col-md-2" style="margin-bottom: 3px;">
                    <label>Plafond individuel</label>
                    <input class="form-control" placeholder="Plafond" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="itemToAdd.plafond" type="text" mask="separator">
                </div>
                <div class="col col-md-2" style="margin-bottom: 3px;">
                    <label>Plafond famille</label>
                    <input class="form-control" placeholder="Plafond_famille" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="itemToAdd.plafond_famille" type="text" mask="separator">
                </div>
                <div class="col-md-1">
                    <br>
                    <button type="button" class="btn btn-md custom_btn_primary pull-right" (click)="onAddToList()">
                        <i class="fa fa-plus"></i>&nbsp; Ajouter
                    </button>
                </div>

                <table class="table table-stripped table-bordered table-hover" style="margin-top: 5px;">
                    <thead>

                        <tr class="custom-table-head">
                            <th>
                                <a style="cursor: pointer" (click)="currentPage = 0; getItemsPlafondTransaction()"
                                    title="Actualiser">
                                    <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                            </th>
                            <th>Périodicité</th>
                            <th>Nombre de transaction individuel</th>
                            <th>Nombre de transaction famille</th>
                            <th>Plafond indivuel</th>
                            <th>Plafond famille</th>
                            <th class="txt-align-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of itemsPlafondTransaction; let indice = index">
                            <td class="txt-align-center">{{indice+1}}</td>
                            <td>{{ item?.periodicite_libelle}}</td>
                            <td>{{ item?.nombre_transaction | integerFormat}}</td>
                            <td>{{ item?.nombre_transaction_famille | integerFormat}}</td>
                            <td>{{ item?.plafond | integerFormat}}</td>
                            <td>{{ item?.plafond_famille | integerFormat}}</td>
                            <td>
                                <div class="custom-td-action">

                                    <a title="Supprimer" (click)="itemsPlafondTransaction.splice(indice,1)"
                                        class="custom-btn-delete">
                                        <i class="fa fa-trash"></i></a>

                                    <a title="Modifier" (click)="updateRow(item)" class="custom-btn-update">
                                        <i class="fa fa-edit"></i></a>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="!itemsPlafondTransaction || itemsPlafondTransaction.length == 0">
                            <td colspan="12">
                                <div class="col-md-12 txt-align-center">
                                    Aucune donnée disponible
                                </div>
                            </td>
                        </tr>
                    </tbody>


                </table>




            </div>

        </div>

        <div class="modal-footer modal-footer-custom">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="text-align:right">

                <button type="button" class="btn btn-md btn-cancel" (click)="modalRefDynamicPlafondTransacton.hide()">
                    Annuler
                </button>
                &nbsp;&nbsp;

                <button (click)="savePlafondTransaction()" type="button" class="btn btn-md custom_btn_primary"
                    [class.auth-spinner]="loading" [disabled]="loading">
                    Sauvegarder
                </button>
            </div>
        </div>
    </ng-template>


    <ng-template #templateReseauSoinIntervalleConfig>
        <div class="modal-header">
            <h4 class="modal-title pull-left">
                {{garantieRow.libelle}} / Réseau de soin
            </h4>
            <button mat-icon-button class="pull-right" (click)="modalRefRseauSoinIntervalle.hide()"
                aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" [ngBusy]="{
busy: busySave,
message: 'Veuillez patienter ...',
backdrop: false
}">
            <div class="row">
                <div class="col col-md-2">
                    <label>Jour</label>

                    <ng-select [clearable]="true" [(ngModel)]="itemToAddReseauIntervalle.jour" name="jour"
                        placeholder="Choisissez périodicité" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsDays" [value]="item.code">{{
                            item?.libelle}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col col-md-2">
                    <label>Heure debut</label>
                    <input class="form-control" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="itemToAddReseauIntervalle.heure_debut" type="time">
                </div>
                <div class="col col-md-2" style="margin-bottom: 3px;">
                    <label>Heure fin</label>
                    <input class="form-control" [ngModelOptions]="{standalone:true}"
                        [(ngModel)]="itemToAddReseauIntervalle.heure_fin" type="time">
                </div>

                <div class="col col-md-2">
                    <label>Réseau de soin</label>

                    <ng-select [clearable]="true" [(ngModel)]="itemToAddReseauIntervalle.reseau_de_soin_id"
                        placeholder="Choisissez réseau de soin" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsReseauDeSoin" [value]="item.id">{{
                            item?.libelle}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-2">
                    <br>
                    <button type="button" class="btn btn-md custom_btn_primary pull-right"
                        (click)="onAddToListReseauIntervalle()">
                        <i class="fa fa-plus"></i>&nbsp; Ajouter
                    </button>
                </div>

                <table class="table table-stripped table-bordered table-hover" style="margin-top: 5px;">
                    <thead>

                        <tr class="custom-table-head">
                            <th>
                                <a style="cursor: pointer" (click)="currentPage = 0; getItemsReseauIntervalle()"
                                    title="Actualiser">
                                    <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                            </th>
                            <th>Jour</th>
                            <th>Heure debut</th>
                            <th>Heure fin</th>
                            <th>Réseau de soin</th>
                            <th class="txt-align-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of itemsReseauIntervalle; let indice = index">
                            <td class="txt-align-center">{{indice+1}}</td>
                            <td>{{ item?.jour_libelle}}</td>
                            <td>{{ item?.heure_debut}}</td>
                            <td>{{ item?.heure_fin}}</td>
                            <td>{{ item?.reseau_de_soin_libelle}}</td>
                            <td>
                                <div class="custom-td-action">

                                    <a title="Supprimer" (click)="itemsReseauIntervalle.splice(indice,1)"
                                        class="custom-btn-delete">
                                        <i class="fa fa-trash"></i></a>
                                    <a title="Modifier" (click)="updateRowReseauIntervalle(item)"
                                        class="custom-btn-update">
                                        <i class="fa fa-edit"></i></a>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="!itemsReseauIntervalle || itemsReseauIntervalle.length == 0">
                            <td colspan="12">
                                <div class="col-md-12 txt-align-center">
                                    Aucune donnée disponible
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer modal-footer-custom">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="text-align:right">

                <button type="button" class="btn btn-md btn-cancel" (click)="modalRefRseauSoinIntervalle.hide()">
                    Annuler
                </button>
                &nbsp;&nbsp;

                <button (click)="saveReseauIntervalle()" type="button" class="btn btn-md custom_btn_primary"
                    [class.auth-spinner]="loading" [disabled]="loading">
                    Sauvegarder
                </button>
            </div>
        </div>
    </ng-template>